'use strict';

Object.defineProperties(exports, { __esModule: { value: true }, [Symbol.toStringTag]: { value: 'Module' } });

const React = require('react');
const reactAriaComponents = require('react-aria-components');
const Modal_Content = require('./Content.cjs.js');
const Modal_ContentBody = require('./ContentBody.cjs.js');
const Modal_ContentFooter = require('./ContentFooter.cjs.js');
const Modal_ContentHeader = require('./ContentHeader.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const ModalRoot = ({ children, isOpen, onOpenChange }) => {
  return React__default.default.createElement(reactAriaComponents.DialogTrigger, { isOpen, onOpenChange }, children);
};
const Modal = {
  Content: Modal_Content.ModalContent,
  ContentBody: Modal_ContentBody.ModalContentBody,
  ContentFooter: Modal_ContentFooter.ModalContentFooter,
  ContentHeader: Modal_ContentHeader.ModalContentHeader,
  Root: ModalRoot
};

exports.Modal = Modal;
exports.ModalRoot = ModalRoot;
exports.default = Modal;
//# sourceMappingURL=Modal.cjs.js.map
